import { z } from 'zod'
import { isValidIranianCompanyNationalId } from '@/utils/nationalId'

export const NationalIdSchema = z.object({
  company_national_id: z
    .string({ required_error: 'وارد کردن شناسه ملی الزامی است' })
    .length(11, 'شناسه ملی باید ۱۱ رقم باشد')
    .refine((data) => isValidIranianCompanyNationalId(data), {
      message: 'شناسه ملی وارد شده معتبر نیست',
    }),
})

export type NationalIdModel = z.infer<typeof NationalIdSchema>
